import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'

/**
 * Zeigt einen Info Text an
 */
@Component({
  selector: 'lib-info',
  imports: [MatCardModule, MatIconModule],
  templateUrl: './info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './info.component.scss',
})
export class InfoComponent {}
